import { useFlag } from '@unleash/proxy-client-vue';
import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import environmentPropertiesStore from '@rygen/rygen-ui/env/EnvironmentPropertiesStore';
import { Optional } from '@rygen/rygen-ui/model';

interface UseMapTileServiceResponse {
  accessToken: ComputedRef<string>;
  attribution: ComputedRef<Optional<string>>;
  isStadiaMapsEnabled: ReturnType<typeof useFlag>;
  mapTileUrl: ComputedRef<string>;
}

export const useMapTileService = (): UseMapTileServiceResponse => {
  const isStadiaMapsEnabled = useFlag('stadia-maps-feat-flag');

  const mapboxAccessToken = environmentPropertiesStore.getValue(
    'MAPBOX_ACCESS_TOKEN',
  );

  const stadiaApiKey = environmentPropertiesStore.getValue('STADIA_API_KEY');

  const accessToken = computed(() => {
    return isStadiaMapsEnabled.value ? stadiaApiKey : mapboxAccessToken;
  });

  const mapTileUrl = computed(() => {
    return isStadiaMapsEnabled.value
      ? `https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=${stadiaApiKey}`
      : `https://api.mapbox.com/styles/v1/rygen-devops/cl34ipiyh001g14ph4jyx48i5/tiles/{z}/{x}/{y}?access_token=${mapboxAccessToken}`;
  });

  const attribution = computed(() => {
    return isStadiaMapsEnabled.value
      ? '&copy; <a href="https://stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
      : undefined;
  });

  return {
    accessToken,
    attribution,
    isStadiaMapsEnabled,
    mapTileUrl,
  };
};
